import {ApolloClient, createHttpLink, from, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import { errorLink } from './errorLink';
import { getToken } from 'utils/auth';
import { buildWebRequestHeaders } from 'utils/webRequestHeaders';

const httpLink = createHttpLink({
    uri: '/api/portal/graphql',
});

const authLink = setContext((_, {headers}) => {
    const token = getToken();
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
            ...buildWebRequestHeaders(),
        },
    };
});

export const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});
